import List from '@zenbusiness/zui/List';
import ZListItem from '@zenbusiness/zui/ListItem';
import ZPageContainer from '@zenbusiness/zui/PageContainer';
import ZPageHeader from '@zenbusiness/zui/PageHeader';
import { superstyled } from '@zenbusiness/zui/styles';

export const ListCard = superstyled({
  tag: List,
  name: 'BusinessOverview',
  slot: 'ListCard',
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: '1rem',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },

    [theme.breakpoints.up('lg')]: {
      gap: '1.5rem',
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  }),
});

export const ListItem = superstyled({
  tag: ZListItem,
  name: 'BusinessOverview',
  slot: 'ListItem',
  styles: () => ({
    padding: 0,
  }),
});

export const Container = superstyled({
  tag: ZPageContainer,
  name: 'BusinessOverview',
  slot: 'Container',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: 0,
  }),
});

export const Header = superstyled({
  tag: ZPageHeader,
  name: 'BusinessOverview',
  slot: 'Header',
  styles: () => ({
    marginBottom: 0,
  }),
});
